




































































import _ from "lodash";
import { MaterielApi } from "../api/MaterielApi";
import { DateUtils } from "../utils/DateUtils";
import DateInput from "../core/Forms/DateInput.vue";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import Pagination from "../core/UI/Pagination.vue";
import HistoriqueGroupe from "./HistoriqueGroupe.vue";
import MouvementDetailModal from "./MouvementDetailModal.vue";

export default {
    name: "HistoriquePanel",
    components: {
        DateInput,
        HistoriqueGroupe,
        MouvementDetailModal,
        Pagination,
    },
    props: {
        refreshKey: Number,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            groupes: [],
            paginator: null,
            page: 1,
            paginationKey: 0,
            search: "",
            typeFilter: "",
            dateFromStr: "",
            dateToStr: "",
            totals: { all: 0, out: 0, in: 0 },
            detailMouvement: null,
            showDetailModal: false,
            loading: false,
            debouncedReload: null,
        };
    },
    created() {
        this.debouncedReload = _.debounce(this.reload, 300);
        this.load();
        this.loadTotals();
    },
    computed: {
        totalPages(): number {
            return this.paginator ? this.paginator.total_pages : 0;
        },
    },
    methods: {
        params(): any {
            let params: any = {
                page: this.page,
                limit: 20,
            };

            if (this.search) {
                params.search = this.search;
            }
            if (this.typeFilter) {
                params.type = this.typeFilter;
            }

            let dateFrom = DateUtils.dateStrToSql(this.dateFromStr);
            if (dateFrom) {
                params.date_from = dateFrom;
            }

            let dateTo = DateUtils.dateStrToSql(this.dateToStr);
            if (dateTo) {
                params.date_to = dateTo;
            }

            return params;
        },
        load(): void {
            let self = this;
            self.loading = true;
            self.MaterielApi.getHistorique(self.params())
                .then(function (res) {
                    self.groupes = res.data;
                    self.paginator = res.paginator;
                    self.loading = false;
                })
                .catch(function () {
                    self.groupes = [];
                    self.loading = false;
                });
        },
        /**
         * Compteurs d'en-tête : le flux plat est paginé, un appel `limit=1`
         * suffit donc à récupérer le total de chaque type.
         */
        loadTotals(): void {
            let self = this;
            Promise.all([
                self.MaterielApi.getMouvements({ limit: 1 }),
                self.MaterielApi.getMouvements({ limit: 1, type: "out" }),
                self.MaterielApi.getMouvements({ limit: 1, type: "in" }),
            ])
                .then(function (res) {
                    self.totals = {
                        all: res[0].paginator ? res[0].paginator.total_count : 0,
                        out: res[1].paginator ? res[1].paginator.total_count : 0,
                        in: res[2].paginator ? res[2].paginator.total_count : 0,
                    };
                })
                .catch(function () {
                    self.totals = { all: 0, out: 0, in: 0 };
                });
        },
        loadPage(page: number): void {
            this.page = page;
            this.load();
        },
        /** Retour à la première page après un changement de filtre. */
        reload(): void {
            this.page = 1;
            this.paginationKey++;
            this.load();
        },
        openDetail(mouvement): void {
            this.detailMouvement = mouvement;
            this.showDetailModal = true;
        },
        deleteFromModal(mouvement): void {
            this.showDetailModal = false;
            this.deleteMouvement(mouvement);
        },
        deleteMouvement(mouvement): void {
            let self = this;
            ConfirmSuppression.demanderRaison("Supprimer ce mouvement ?").then(
                function (raison) {
                    if (raison === null) {
                        return;
                    }
                    self.MaterielApi.deleteMouvement(mouvement.id, raison)
                        .then(function () {
                            self.$emit("toast", {
                                message: "Mouvement supprimé",
                                kind: "success",
                            });
                            self.load();
                            self.loadTotals();
                            self.$emit("refresh");
                        })
                        .catch(function (error) {
                            let data =
                                (error &&
                                    error.response &&
                                    error.response.data) ||
                                {};
                            self.$emit("toast", {
                                message:
                                    data.message ||
                                    (data.error && data.error.message) ||
                                    "Suppression impossible",
                                kind: "error",
                            });
                        });
                }
            );
        },
    },
    watch: {
        refreshKey: function () {
            this.load();
            this.loadTotals();
        },
        search: function () {
            this.debouncedReload();
        },
        typeFilter: function () {
            this.reload();
        },
        dateFromStr: function () {
            this.debouncedReload();
        },
        dateToStr: function () {
            this.debouncedReload();
        },
    },
};
